import styled from 'styled-components';

import variables from '../../../styles/variables';
import Button from '../../UI/Button/Button';

export const Container = styled.div`
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;
  @media screen and (max-width: 1024px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1em;
  }

  h1 {
    font-size: 2.625rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  h2 + h3 {
    margin-top: -1rem;
  }

  button.functionalTextLink,
  a {
    font-weight: bold;

    :not(p > &) {
      margin: 1rem 0;
    }
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  margin: 15px auto 30px auto;
  align-items: center;
  padding: 10px 0;
  @media screen and (max-width: 1023px) {
    padding: 0;
    margin: 15px auto;
    flex-direction: column;
    text-align: center;
    max-width: ${variables.mobileWidth}px;
  }
  @media screen and (max-width: 768px) {
    margin: 0 auto 50px;
  }
`;

export const Headline = styled.h1`
  color: ${variables.colorRed};
  margin: 0;
  text-transform: none;
`;

export const ImageContainer = styled.div`
  margin-bottom: 1.5rem;
  display: block;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  margin-bottom: 0.75rem;

  @media only screen and (min-width: 641px) {
    display: inline-flex;
  }
`;
